module.exports = __webpack_public_path__ + "static/media/us.50162f60.svg";